// extracted by mini-css-extract-plugin
export default {"groupError":"GroupValidationMessage_groupError__C0EhS"};